module.exports = __webpack_public_path__ + "img/icon_success.e522516f.png";